webpackJsonp([915738553496],{

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(25);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _typography = __webpack_require__(27);
	
	var _colors = __webpack_require__(35);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/named */
	var Button = /*#__PURE__*/(0, _reactEmotion2.default)("a", {
	  target: "eio46h50"
	})("position:relative;display:inline-block;padding:10px 15px;color:#fff;font-weight:700;margin:", (0, _typography.rhythm)(1), " 0;background:", _colors2.default.primaryColorLight, ";border-radius:5px;font-family:", ["Lato", "sans-serif"].join(","), ";cursor:pointer;border:1px solid ", _colors2.default.primaryColorLight, ";text-decoration:none;&:hover{color:", _colors2.default.primaryColorLight, ";background:#fff;}");
	/* eslint-enable import/named */
	exports.default = Button;
	module.exports = exports["default"];

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactHelmet = __webpack_require__(72);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _button = __webpack_require__(296);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _colors = __webpack_require__(35);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OptOutButton = /*#__PURE__*/(0, _reactEmotion2.default)(_button2.default, {
	  target: "e1n5q1fj0"
	})(function (props) {
	  return props.optedOut ? "color: " + _colors2.default.primaryColorLight + ";\n  background: #fff;\n  cursor: default;" : "";
	}, ";");
	
	var Privacy = function (_React$Component) {
	  _inherits(Privacy, _React$Component);
	
	  function Privacy(props) {
	    _classCallCheck(this, Privacy);
	
	    // Default state based on whether opt out cookie exists
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      optedOut: false
	    };
	    return _this;
	  }
	
	  // Update state on mount
	
	
	  Privacy.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      optedOut: document && document.cookie && document.cookie.indexOf("ga-disable-UA-54367226-6") > -1 || false
	    });
	  };
	
	  Privacy.prototype.setOptOutCookie = function setOptOutCookie() {
	    // Check that opt out function exists, then call it
	    if (typeof window.gaOptout === "function") {
	      window.gaOptout();
	      this.setState({
	        optedOut: true
	      });
	    } else {
	      console.error("GA opt out function not found.");
	    }
	  };
	
	  Privacy.prototype.render = function render() {
	    var _this2 = this;
	
	    return React.createElement(
	      "div",
	      null,
	      React.createElement(
	        _reactHelmet2.default,
	        null,
	        React.createElement("meta", { name: "robots", content: "noindex" }),
	        React.createElement(
	          "title",
	          null,
	          "Christian Gaetano \u2014 Opt Out of Site Tracking"
	        ),
	        React.createElement("link", { rel: "canonical", href: "https://christiangaetano.com/privacy/" }),
	        React.createElement("meta", {
	          name: "description",
	          content: "WARNING: Spy satellites and Russian bots not welcome here! \uD83D\uDEAB\uD83D\uDEF0 Check out my site's emphasis on privacy, and find out how to opt out of all analytics tracking."
	        })
	      ),
	      React.createElement(
	        "h1",
	        null,
	        "It'll Be Like You Were Never Even Here..."
	      ),
	      React.createElement(
	        "p",
	        null,
	        "With every company under the sun offering its own tracking platform and gating content with \u201CWhat's your favorite color?\u201D questions at every opportunity, I don't blame internet users for being concerned about privacy. Since this is a place to simply kick back, relax, and enjoy what the web has to offer, I work hard to make sure your privacy is respected."
	      ),
	      React.createElement(
	        "p",
	        null,
	        "While I do use Google Analytics for collecting some basic visitor info, I don't take in any data that can uniquely identify you, and you can easily opt out if you want! On the other hand, if you",
	        " ",
	        React.createElement(
	          "i",
	          null,
	          "do"
	        ),
	        " want to tell me your favorite color, the name of your dog (yes please), or just how you're feeling today, just",
	        " ",
	        React.createElement(
	          "a",
	          { href: "mailto:hello@christiangaetano.com" },
	          "shoot me an email"
	        ),
	        "!"
	      ),
	      React.createElement(
	        "h2",
	        null,
	        "Analytics for \u201CDo Not Track\u201D Users"
	      ),
	      React.createElement(
	        "p",
	        null,
	        "If you've already enabled",
	        " ",
	        React.createElement(
	          "a",
	          { href: "https://support.google.com/chrome/answer/2790761?co=GENIE.Platform%3DDesktop&hl=en" },
	          "\u201CDo Not Track\u201D mode"
	        ),
	        " ",
	        "in your web browser, you're covered! Err\u2026not covered. The point is, I'm not collecting ",
	        React.createElement(
	          "b",
	          null,
	          "any"
	        ),
	        " analytics data on you. You're a speck of dust in the wind, a ghost, an enigma\u2026"
	      ),
	      React.createElement(
	        "h2",
	        null,
	        "Opting Out of Tracking"
	      ),
	      React.createElement(
	        "p",
	        null,
	        "Even if you're not enough of a privacy guru to disable tracking",
	        " ",
	        React.createElement(
	          "i",
	          null,
	          "everywhere"
	        ),
	        ", you can still",
	        " ",
	        React.createElement(
	          "a",
	          {
	            href: "#",
	            onClick: function onClick(event) {
	              event.preventDefault();
	              _this2.setOptOutCookie();
	            }
	          },
	          "opt out of analytics tracking on my site only"
	        ),
	        ". It's okay\u2026I get it, I can be a little abrasive at times. No hard feelings, though! All you have to do is click the button below, and you'll be opted out faster than you can say",
	        " ",
	        React.createElement(
	          "code",
	          null,
	          "tinfoilHat.activate()"
	        ),
	        "."
	      ),
	      React.createElement(
	        OptOutButton,
	        {
	          role: "button",
	          onClick: function onClick() {
	            return _this2.setOptOutCookie();
	          },
	          optedOut: this.state.optedOut
	        },
	        this.state.optedOut ? "You're invisible! 🙈Congratulations! 🎉" : "Opt Out of Analytics Tracking"
	      )
	    );
	  };
	
	  return Privacy;
	}(React.Component);
	
	exports.default = Privacy;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-js-df0414ec61f8c059d998.js